import styled from 'styled-components'

export const AppStyled = styled.div`
  background: black;
  color: #fff;
  display: grid;
  grid-template-areas:
    'sidebar map'
    'sidebar map';
  grid-template-columns: 20rem auto;
  width: 100vw;
  height: 100vh;

  @media only screen and (max-width: ${({ theme }) => theme.responsive.small}) {
    grid-template-columns: 3rem;
  }
`
